import { render, staticRenderFns } from "./AccountStatements.vue?vue&type=template&id=51305911&scoped=true"
import script from "./AccountStatements.vue?vue&type=script&lang=js"
export * from "./AccountStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51305911",
  null
  
)

export default component.exports